<template>
    <!--                                     <v-alert border="left" class="rounded-0" colored-border dense color="orange"
                                            elevation="6">
                                            <div class="font-weight-regular text-body-1">
                                                <v-icon color="orange">mdi-circle-small</v-icon>
                                                La contraseña debe contener al menos una letra mayúscula.
                                            </div>
                                            <div class="font-weight-regular text-body-1">
                                                <v-icon color="orange">mdi-circle-small</v-icon>
                                                La longitud total de la contraseña debe ser de al menos 8 caracteres.
                                            </div>
                                        </v-alert> -->
    <div class="d-flex justify-center ">
        <v-card elevation="6" class="pa-8" width="510px">
            <div class=" my-9">
                <v-img max-width="240px" max-height="70px" src="@/assets/Logo-bt-07.png" />
            </div>
            <v-card-text>
                <div class="d-flex flex-column align-start font-weight-regular primary--text text-h5 mb-8 ">
                    CAMBIAR CONTRASEÑA
                </div>
                <ValidationObserver ref=" obs" v-slot="{ invalid }">
                    <v-form v-model="valid" @submit.prevent="cambiarPass">
                        <v-row class="d-flex flex-column">
                            <v-col cols="12" md="12">
                                <ValidationProvider rules="required|alpha_num|confirmed:confirmation" v-slot="v">
                                    <v-text-field outlined v-model="confirmation" :error-messages="v.errors[0]"
                                        :append-icon="show1 ? 'mdi-eye' : 'mdi-eye-off'"
                                        :type="show1 ? 'text' : 'password'" name="password" label="Contraseña"
                                        @click:append="show1 = !show1"></v-text-field>
                                </ValidationProvider>
                            </v-col>
                            <v-col cols="12" md="12">
                                <ValidationProvider vid="confirmation" v-slot="v">
                                    <v-text-field outlined v-model="password"
                                        :append-icon="show2 ? 'mdi-eye' : 'mdi-eye-off'"
                                        :type="show2 ? 'text' : 'password'" :error-messages="v.errors[0]"
                                        label="Confirmar contraseña" class="input-group--focused"
                                        @click:append="show2 = !show2"></v-text-field>
                                </ValidationProvider>
                            </v-col>
                            <v-col cols="12" md="12">
                                <v-btn :disabled="invalid" elevation="0" block class="pa-6" color="primary"
                                    type="cambiarPass">
                                    Actualizar contraseña
                                </v-btn>
                            </v-col>
                        </v-row>
                    </v-form>
                </ValidationObserver>
            </v-card-text>
        </v-card>
    </div>
</template>


<script>

import { mapActions, mapGetters } from 'vuex';
import { ValidationProvider, ValidationObserver } from 'vee-validate';

export default {
    components: {

        ValidationObserver,
        ValidationProvider,
    },

    data() {
        return {
            hash: '',
            valid: false,
            show1: false,
            show2: false,
            password: '',
            confirmation: '',
        }
    },
    computed: {
        ...mapGetters('notificaciones', ['loading'])
    },

    created() {
        //let uri = window.location.search.substring(1);
        //let params = new URLSearchParams(uri);
        //this.hash = params.get('v')
        //this.getValidation({ hash: this.hash })
    },
    methods: {
        ...mapActions('notificaciones', ['showSnack']),
        ...mapActions(['getValidation']),

        goToLogin() {
            this.$router.push('/Login').catch(() => { })
        },
        preventArrowKeys(event) {
            if (event.keyCode === 38 || event.keyCode === 40) {
                event.preventDefault();
            }
        },
        cambiarPass() {
            this.$refs.obs.validate().then(result => {
                if (result) {
                    this.getValidation({ hash: this.hash, pwd: this.password })
                } else {
                    console.log('Formulario inválido, no se puede enviar la petición');
                }
            });

        },
    },

}

</script>


<style>
.coloreado {
    background-color: black;
}
</style>